import { Component, Input, OnChanges, SimpleChanges, TemplateRef, ElementRef, ViewChild } from "@angular/core";
import { TimelineToggleService, HttpService, AppConfig, JitsiService } from "@src/app/shared/services";
import { Timeline, Appointment, PatientDocument, ScanDocument } from "@src/app/shared/entities";
import { ApiResources } from "@shared/helpers";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { ProgressData, ObEncounter, PatientProfile } from "../../models";
import { Router } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';
import { LabBillDetailModel } from "src/app/areas/admin/labs/pages/models/lab-booking-model";
import { OB } from "@src/app/areas/admin/full-transcript/pages/ob-report/ob.namespace";
import { IvfEncounter } from "../../models/ivf-encounter.model";
import { GYN } from "../../../areas/admin/gyn-encounter/gyn.namespace";

enum TimelineAction {
    MedicationsAdded = 8,
    MedicationsUpdated = 9,
    NotesAdded = 10,
    NotesUpdated = 11,
    FollowUpAdded = 12,
    FollowUpUpdated = 13
}

class ViewModel {
    documents: Array<any>;
    data: string;
    medications: Array<any>;
    notes: any;
    followUp: any;
}

@Component({
    selector: "timeline-widget",
    styleUrls: ["./timeline.widget.css"],
    templateUrl: "./timeline.widget.html"
})
export class TimelineWidget implements OnChanges {

    @Input() isAdmission: boolean;
    @Input() eid: string;
    @Input() encounterType: string;

    @ViewChild("videoPlayer", { static: false }) videoPlayer: ElementRef;
    modalRef: NgbModalRef;
    selected: Timeline;
    viewData: ViewModel;
    loadingDocument: boolean;
    documentError: boolean;
    showTranscript = false;
    appointment: Appointment;
    ob: Array<ObEncounter>;
    appointmentCounts: Array<Appointment>;
    showOpdVisit = false;
    showDocument = false;
    showPacs = false;
    documentsRecord: Array<PatientDocument>;
    showPac = false;
    pacsImg: ScanDocument;
    selectedDocument: PatientDocument;
    selectedPacsImg: ScanDocument;
    document: PatientDocument;
    loadingPacsImg: boolean;
    labBookingDetail: Array<LabBillDetailModel>;
    showLabs = false;
    selectedLabBookingDetail: LabBillDetailModel;
    anaesthesia: Array<ObEncounter>;
    reports: Array<ScanDocument>;
    openAllFlag = false;
    showAll = true;
    showOpdPrescription = false;
    showOpdVisits = false;
    isDocument = false;
    filterText: string;
    defaultImgUrl = 'assets/images/broken.png';

    obEncounter: ObEncounter;
    ancCards: OB.AncCards;
    ancCardGeneration: OB.AncCardGeneration;
    obPrescriptionRecords: Array<ObEncounter>;
    showMessageBox: boolean;
    loadMessageWindow: boolean;
    patient: PatientProfile;
    husbandName: string;
    ivfEncounter: IvfEncounter;
    fertilitySection: GYN.NewGynHistory;
    bloodGroup: string;
    constructor(
        public toggleService: TimelineToggleService,
        private readonly modalService: NgbModal,
        private readonly httpService: HttpService,
        private readonly router: Router,
        private readonly sanitizer: DomSanitizer,
        private readonly jitsiService: JitsiService,
    ) {
        this.toggleService.encryptedAppointmentId = this.eid;
        this.toggleService.fetch();
        this.appointment;
        this.labBookingDetail = new Array<LabBillDetailModel>();
        this.documentsRecord = new Array<PatientDocument>();
        this.ob = new Array<ObEncounter>();
        this.anaesthesia = new Array<ObEncounter>();
        this.reports = new Array<ScanDocument>();
        this.showMessageBox = false;
        this.loadMessageWindow = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.eid.currentValue) {
            this.toggleService.encryptedAppointmentId = this.eid;
            this.toggleService.isAdmission = this.isAdmission;
            this.toggleService.fetch();
            this.findAppointment(this.eid);
            this.findDashboard();
        }
    }

    onProgress(progressData: ProgressData) {
        if (progressData.loaded === progressData.total) {
            this.loadingDocument = false;
        }
    }

    onProgressImg(progressData: ProgressData) {
        if (progressData.loaded === progressData.total) {
            this.loadingPacsImg = false;
        }
    }


    onDocumentLoad() {
        this.loadingDocument = false;
    }

    onPacsLoad() {
        this.loadingPacsImg = false;
    }
    onDocumentError() {
        this.loadingDocument = false;
        this.documentError = true;
    }

    toggleVideo() {
        this.videoPlayer.nativeElement.play();
    }

    onCloseModal() {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = undefined;
            this.loadingDocument = undefined;
            this.documentError = undefined;
        }
    }


    safe = (url: any) => {
        if (url) {
            return `${ApiResources.getURI(ApiResources.resources.base, ApiResources.resources.getProfileImage)}?imagePath=${url}`;
        }
        return this.defaultImgUrl;
    }

    view(item: Timeline, content?: TemplateRef<any>) {
        this.selected = item;
        this.selected.viewLoading = true;
        this.modalRef = this.modalService.open(content,
            {
                backdrop: "static",
                keyboard: false,
                centered: true,
                windowClass: "custom-modal effect-scale",
                size: "lg"
            });

        setTimeout(() => {
            this.httpService
                .post<ViewModel>(ApiResources.getURI(ApiResources.timeline.base, ApiResources.timeline.view), { id: item.timelineId.toString() })
                .pipe(finalize(() => this.selected.viewLoading = false))
                .subscribe(
                    (response: ViewModel) => {

                        this.viewData = response;

                        if (this.viewData.documents) {
                            this.viewData.documents.forEach(document => {
                                document.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFileGet)}?id=${document.patientDocumentId}&url=${document.documentUrl}`);

                                document.isImage = document.contentType.indexOf("pdf") < 0;
                            });
                        }

                        if (this.viewData.data) {
                            switch (this.selected.timelineActionId as TimelineAction) {
                                case TimelineAction.MedicationsAdded:
                                case TimelineAction.MedicationsUpdated:
                                    this.viewData.medications = JSON.parse(this.viewData.data);
                                    break;
                                case TimelineAction.NotesAdded:
                                case TimelineAction.NotesUpdated:
                                    this.viewData.notes = JSON.parse(this.viewData.data);
                                    break;
                                case TimelineAction.FollowUpAdded:
                                case TimelineAction.FollowUpUpdated:
                                    this.viewData.followUp = JSON.parse(this.viewData.data);
                                    break;
                                default:
                            }
                        }
                    }
                );
        });
    }
    findAppointment(appointmentId: string) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .subscribe((response: Appointment) => {
                this.appointment = response;
                this.loadMessageWindow = true;
                this.findPatientDetails();
               
            });
    }
    toggleIt() {
        this.toggleService.toggle();
        if (this.toggleService.showBox == false) {
            $("body")[0].setAttribute("data-timeline-size", "timelineabsent");
        } else {
            $("body")[0].setAttribute("data-timeline-size", "timeline");
        }
    }
    private findOrderPrescription() {
        let PatientId: number = this.appointment.patientId;
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchFullTrascript), { patientId: PatientId })
            .subscribe((response: Array<ObEncounter>) => {
                if (response.length > 0) {
                    this.obPrescriptionRecords = response;
                }
            });
    }

    close() {
        try {
            this.modalRef.close();
            this.modalRef = undefined;
        } catch (e) {
            // ignored;
        }
    }

    onClickPrescription(item: ObEncounter) {
        this.router.navigate([]).then(() => { window.open(`${AppConfig.settings.baseWeb}/#/print-prescription/${"ob-encounter"}/${item.encryptedAppointmentId}`, "_blank"); });

    }


    private fetchAppointmentCounts() {
        const request = {
            encryptedPatientId: this.appointment.encryptedPatientId
        }
        this.httpService
            .post<Array<Appointment>>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.fetch), request)
            .subscribe(
                (response: Array<Appointment>) => {
                    if (response.length > 0) {
                        this.appointmentCounts = response;
                    }
                }
            );
    }
    openAll() {
        if (this.openAllFlag === true) {
            this.showTranscript = false;
            this.showOpdVisit = false;
            this.showDocument = false;
            this.showPac = false;
            this.showLabs =false;
            this.showPacs = false;
            this.openAllFlag = false;
            return;
        }
        this.showTranscript = true;
        this.onClickTranscript();
        this.showOpdVisit = true;
        this.onClickOpdVisit();
        this.showDocument = true;
        this.onClickOpdVisit();
        this.showPac = true;
        this.onPac();
        this.showLabs = true;
        this.onClickLabs();
        this.showPacs = true;
        this.onClickImgReport();
        this.openAllFlag = true;
    }

    showSection(flag: string) {
         if (flag == 'opdPres') {
            this.onClickTranscript();
            this.showTranscript = !this.showTranscript;            
        } else {
            if (this.openAllFlag === false) {
                this.showTranscript = false;
            }
        }
        if (flag == 'opdVisit') {
            this.onClickOpdVisit();
            this.showOpdVisit = !this.showOpdVisit;            
        } else {
            if (this.openAllFlag === false) {
                this.showOpdVisit = false;
            }
        }
        if (flag == 'attachments') {
            this.onClickAttachments();
            this.showDocument = !this.showDocument;            
        } else {
            if (this.openAllFlag === false) {
                this.showDocument = false;
            }
        }
        if (flag == 'PAC') {
            this.onPac();
            this.showPac = !this.showPac;            
        } else {
            if (this.openAllFlag === false) {
                this.showPac = false;
            }
        }
        if (flag == 'investigation') {
            this.onClickLabs();
            this.showLabs = !this.showLabs;
        } else {
            if (this.openAllFlag === false) {
                this.showLabs = false;
            }
        }
        if (flag == 'pacsImages') {
            this.onClickImgReport();
            this.showPacs = !this.showPacs;
        } else {
            if (this.openAllFlag === false) {
                this.showPacs = false;
            }
        }
    }
    onClickTranscript() {
        if (this.showTranscript) {
            this.findAppointment(this.eid);
            
        }
    }

    onClickOpdVisit() {
        if (this.showOpdVisit) {
            this.findAppointment(this.eid);
            setTimeout(() => {
                this.fetchAppointmentCounts();
            })
        }

    }

    onClickImgReport() {
        if (this.showPacs) {
            this.findAppointment(this.eid);
            //setTimeout(() => {
            //    this.fetchPacsImages();
            //})
        }
    }

    onClickAttachments() {
        if (this.showDocument) {
            this.findAppointment(this.eid);
            setTimeout(() => {
                this.fetchDocuments();
            })
        }
    }
    onPac() {
        if (this.showPac) {
            this.findAppointment(this.eid);
            setTimeout(() => {
                this.findPac();
            })
        }
    }
    onClickLabs() {
        //this.showLabs = !this.showLabs;
        if (this.showLabs) {
            this.findAppointment(this.eid);
            setTimeout(() => {
                this.findLabBookingHeader();
            })
        }
    }
    fetchDocuments() {
        const request =
            { encryptedPatientId: this.appointment.encryptedPatientId }
        this.httpService.post(ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.fetch), request)
            .subscribe((response: Array<PatientDocument>) => {
                if (response[0].patientDocumentId !=0) {
                    this.documentsRecord = response;

                }
            });
    }

    fetchPacsImages() {
        this.httpService.post(ApiResources.getURI(ApiResources.bookScanAppointment.base, ApiResources.bookScanAppointment.fetchPacsImage), this.appointment.patientId)
            .subscribe((response: Array<ScanDocument>) => {
                this.reports = response;
            });
    }

    private findPac() {
        let PatientId: number = this.appointment.patientId;
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchFullTrascript), { patientId: PatientId })
            .subscribe((response: Array<ObEncounter>) => {
                if (response.length > 0) {
                    this.anaesthesia = [];
                    this.ob = response;
                    this.ob.forEach((item: ObEncounter) => {
                        if (item.anaesthesiaRecord != null) {
                            this.anaesthesia.push(item);
                        }
                    })
                }
            });
    }
    onOpenModel(content: TemplateRef<any>, record?: PatientDocument, labRecords?: LabBillDetailModel) {
        this.modalRef = this.modalService.open(content, {
            keyboard: false,
            centered: true,
            windowClass: "document-view-modal custom-modal effect-scale"
        });
        if (record) {
            this.selectedDocument = this.documentsRecord.find(s => s.patientDocumentId == record.patientDocumentId);
            this.prepareDocument(record);
        }
        if (labRecords) {
            this.selectedLabBookingDetail = this.labBookingDetail.find(s => s.newLabBookingDetailId == labRecords.newLabBookingDetailId);
        }

    }
    onOpenPacsModel(content: TemplateRef<any>, report?: ScanDocument) {
        this.modalRef = this.modalService.open(content, {
            keyboard: false,
            centered: true,
            windowClass: "document-view-modal custom-modal effect-scale"
        });

        if (report) {
            this.selectedPacsImg = this.reports.find(x => x.patientId == report.patientId);
            this.preparePacsImg(report);
        }
    }
    private prepareDocument(document?: PatientDocument) {
        if (document)
            this.loadingDocument = true;
        this.document = document;
        this.documentError = false;
        this.document.isImage = this.document.contentType.indexOf("pdf") < 0 && this.document.contentType.indexOf("video") < 0;
        this.document.isVideo = this.document.contentType.indexOf("video") >= 0;

        if (this.document.isImage || this.document.isVideo) {
            this.document.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFileGet)}?id=${this.document.patientDocumentId}&url=${this.document.documentUrl}`);
        }

        if (!this.document.isImage && !this.document.isVideo) {
            this.httpService
                .post(ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFile), { ...document })
                .pipe(finalize(() => { this.loadingDocument = false; }))
                .subscribe(
                    (response: PatientDocument) => {
                        this.document.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${response.base64}`);
                    }
                );
        } else {
            this.loadingDocument = false;
        }
    }


    private preparePacsImg(document: ScanDocument) {
        this.loadingPacsImg = true;
        this.pacsImg = document;
        this.documentError = false;
        this.pacsImg.isImage = this.pacsImg.contentType.indexOf("pdf") < 0 && this.pacsImg.contentType.indexOf("video") < 0;
        this.pacsImg.isVideo = this.pacsImg.contentType.indexOf("video") >= 0;

        if (this.pacsImg.isImage || this.pacsImg.isVideo) {
            this.pacsImg.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFileGet)}?id=${this.pacsImg.scanDocumentId}&url=${this.pacsImg.documentUrl}&type=${'ScanReports'}`);
        }

        if (!this.pacsImg.isImage && !this.pacsImg.isVideo) {
            this.httpService
                .post(ApiResources.getURI(ApiResources.documents.base, ApiResources.documents.downloadFile), { ...document })
                .pipe(finalize(() => { this.loadingPacsImg = false; }))
                .subscribe(
                    (response: ScanDocument) => {
                        this.pacsImg.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64, ${response.base64}`);
                    }
                );

        } else {
            this.loadingPacsImg = false;
        }
    }

    private findLabBookingHeader() {
        let PatientId: number = this.appointment.patientId;
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.labReports), { patientId: PatientId })
            .subscribe((response: Array<LabBillDetailModel>) => {
                if (response.length > 0) {
                    this.labBookingDetail = response;
                }
            });
    }

    onSelect(type: string) {
   
        switch (type) {
            case "Appointments":
                this.showAll = true;
                this.showOpdPrescription = false;
                this.showOpdVisit = false;
                this.showTranscript = false;
                this.showDocument = false;
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.toggleService.fetch(undefined, undefined, 7);
               //this.toggleService.records=this.toggleService.records.filter(s => s.timelineActionId == 7);
                break;
            case "Encounter":
                this.showAll = true;
                this.showOpdPrescription = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = false;
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.toggleService.fetch(undefined, undefined, 14);
                //this.toggleService.records = this.toggleService.records.filter(s => s.timelineActionId == 14);
                break;
            case "Documents":
                this.showAll = true;
                this.showOpdPrescription = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = false;
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.toggleService.fetch(undefined, undefined, 1);
                //this.toggleService.records =this.toggleService.records.filter(s => s.timelineActionId == 1);
                break;
            case "OPD Prescription":
                this.showOpdPrescription = true;
                this.showAll = false;
                this.showTranscript = true;
                this.showOpdVisit = false;
                this.showDocument = false;
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.findOrderPrescription();
                break;
            case "OPD Visits":
                this.showOpdPrescription = false;
                this.showAll = false;
                this.showTranscript = false;
                this.showOpdVisit = true;
                this.showDocument = false
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.fetchAppointmentCounts();
                break;
            case "Attachments":
                this.showOpdPrescription = false;
                this.showAll = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = true
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.fetchDocuments();
                break;
            case "PAC":
                this.showOpdPrescription = false;
                this.showAll = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = false
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = true;
                this.findPac();
                break;
            case "Investigation":
                this.showOpdPrescription = false;
                this.showAll = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = false
                this.showPac = false;
                this.showLabs = true;
                this.showPacs = false;
                this.findLabBookingHeader();
                break;
            case "Pacs Images":
                this.showOpdPrescription = false;
                this.showAll = false;
                this.showTranscript = false;
                this.showOpdVisit = false;
                this.showDocument = false
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = true;
                this.fetchPacsImages();
                break;
            case "All":
                this.showAll = true;
                this.showOpdPrescription = false;
                this.showOpdVisit = false;
                this.showTranscript = false;
                this.showDocument = false;
                this.showPac = false;
                this.showLabs = false;
                this.showPacs = false;
                this.toggleService.fetch();
                break;
            default:
                break;  
                
        }
    }


    onSerach() {
        if (this.filterText && this.filterText.length > 2) {
            var temp = [];

            for (let row of this.toggleService.records) {
                //var stk = `^${this.filterText}`;
                //const regexp = new RegExp(stk.toLowerCase());

                //if (regexp.test(row.description)) { temp.push(row); }
                if (row.description.includes(this.filterText)) { temp.push(row); }

            }
            this.toggleService.records = temp;

        } 
    }

    private findDashboard() {

        const request = { encryptedAppointmentId: this.eid };
        request["isAdmission"] = this.isAdmission;

        this.httpService.post(ApiResources.getURI(ApiResources.ivfEncounter.base, ApiResources.ivfEncounter.find), request)
            .subscribe((response: [IvfEncounter]) => {
                this.ivfEncounter = response["dashboard"];
                this.fertilitySection = this.ivfEncounter &&  this.ivfEncounter.inFertilitySection ? JSON.parse(this.ivfEncounter.inFertilitySection) : null;
                if (this.fertilitySection && this.fertilitySection.bloodGroup && this.fertilitySection.rhType) {
                    this.bloodGroup = this.fertilitySection.bloodGroup + this.fertilitySection.rhType;
                }

            });

    }

    onClickFullTranscipt(value: Appointment) {
        switch (value.encounterType) {
            case "GynEncounter":
                this.router.navigate([]).then(() => { window.open(`${AppConfig.settings.baseWeb}/#/full-transcript/gyn-encounter/${value.encryptedAppointmentId}`, "_blank"); });
                break;
            case "OBEncounter":
                this.router.navigate([]).then(() => { window.open(`${AppConfig.settings.baseWeb}/#/full-transcript/ob-encounter/${value.encryptedAppointmentId}`, "_blank"); });
                break;

        }
    }


    toggleMessageBox() {
        this.showMessageBox = !this.showMessageBox;
    }

    onCall(isPreLoad: boolean = false) {
        this.jitsiService.call({
            accountId: this.appointment.patientAccountId,
            appointmentId: this.appointment.appointmentId,
            appointmentNo: this.appointment.appointmentNo,
            patientThumbnailUrl: this.appointment.patientThumbnailUrl,
            type: 1,
            isPreLoad: isPreLoad
        });
    }




    private findPatientDetails() {
        this.httpService.post<PatientProfile>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.profile), { encryptedPatientId: this.appointment.encryptedPatientId })
            .subscribe((response: PatientProfile) => {
                if (response) {
                    this.patient = response;
                    var detaills = this.patient.relativeDetails[0];
                    if (detaills && detaills.relation == "Husband") {
                        this.husbandName = this.patient.relativeDetails[0].fullName;

                    }
                }


            });
    }
}